import { useLocation, useNavigate } from "react-router-dom";
import { getActiveParamsById } from "../../redux/selectors/ui.selector";
import { PAGES } from "../../utils/constants";
import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import s from "./AddressLink.module.scss";
import { setInitialState } from "../../redux/features/ui/uiSlice";
import { addActiveModel } from "../../redux/actions/player.action";
import { modelsBedroom } from "../../utils/Constants/modelsBedroom";

type AddressLinkT = {
  playerTitle: string;
  onClick: () => void;
};

const AddressLink = ({ playerTitle, onClick }: AddressLinkT) => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const params = new URLSearchParams(location.search);

  // видаляємо параметр
  params.delete("shortId");

  // формуємо новий рядок запиту
  const queryParams = params.toString();
  const navigate = useNavigate();

  let activeItemType = useAppSelector((state) => getActiveParamsById(state)("item_type"));
  let activeBedSizeValue = useAppSelector((state) => getActiveParamsById(state)("bed_size"));

  const activeBedSize = modelsBedroom.find((i) => i.label === activeBedSizeValue)?.labelUI as string;
  // console.log("activeBedSize2", activeBedSize2);
  const { pathname } = useLocation();
  const category = pathname.split("/")[1];

  let actualTitle = "";
  if (activeItemType) {
    actualTitle = activeItemType;
  }
  if (activeBedSize) {
    actualTitle = activeBedSize;
  }
  const collectionCategoryName: any = {
    sofa: {
      start: "Collections / ",
      category: "Sofas /",
      name: actualTitle,
    },
    sectional: {
      start: "Collections / ",
      category: "Sectional",
      name: "",
    },
    ottoman: {
      start: "Collections / ",
      category: "Ottomans /",
      name: actualTitle,
    },
    chair: {
      start: "Collections / ",
      category: "Chairs /",
      name: actualTitle,
    },
    bed: {
      start: "Collections / ",
      category: "Beds & Headboards /",
      name: actualTitle,
    },
  };
  const defailtInfo = {
    start: "Collections / ",
    category: "Categories /",
    name: "Configurator",
  };
  const actualInfo = collectionCategoryName[category] ? collectionCategoryName[category] : defailtInfo;

  return (
    <span className={s.address}>
      <span
        onClick={() => {
          window.location.href = `${PAGES.index}?${queryParams}`;

          dispatch(setInitialState());
          dispatch(addActiveModel({ id: "" }));
        }}
      >
        {actualInfo.start}
      </span>

      {actualInfo.category && <span onClick={() => onClick()}>{actualInfo.category}</span>}
      {actualTitle && <span>{actualTitle}</span>}
    </span>
  );
};

export default AddressLink;
